import { render, staticRenderFns } from "./headerBlock.vue?vue&type=template&id=4c580caa&scoped=true&"
import script from "./headerBlock.vue?vue&type=script&lang=js&"
export * from "./headerBlock.vue?vue&type=script&lang=js&"
import style0 from "./headerBlock.vue?vue&type=style&index=0&id=4c580caa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c580caa",
  null
  
)

export default component.exports